export default __webpack_public_path__ + "static/media/Circle.8fb05be4.svg";